import { ContextData } from '@floating-ui/react-dom-interactions'
import { ChartArea } from 'chart.js'

export const createGradient = (
  colors: string[],
  direction: 'horizontal' | 'vertical',
) => {
  return (context) => {
    const chart = context.chart
    const { ctx, chartArea } = chart
    if (!chartArea) return
    const gradient =
      direction === 'horizontal'
        ? ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0)
        : ctx.createLinearGradient(0, chartArea.top, 0, chartArea.bottom)

    colors.forEach((color, index) => {
      gradient.addColorStop(index / (colors.length - 1), color)
    })
    return gradient
  }
}
